import { render } from "./padresevento.vue?vue&type=template&id=1bea6c1d&scoped=true"
import script from "./padresevento.vue?vue&type=script&lang=js"
export * from "./padresevento.vue?vue&type=script&lang=js"

import "./padresevento.vue?vue&type=style&index=0&id=1bea6c1d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bea6c1d"]])

export default __exports__